export default "__VITE_ASSET__CKKzaVlf__"